const plugin = require('tailwindcss/plugin');

module.exports = {
  corePlugins: {
    container: false
  },
  // purge: {
  //     enabled: true,
  //     content: ['./src/**/*.js'],
  //     options: {
  //         safelist: [/grid-/],
  //     },
  //
  // },
  important: true,

  theme: {
    container: {
      center: true,
      paddingLeft: {
        xs: '4px'
      },
      paddingRight: {
        xs: '4px'
      }
    },
    fontFamily: {
      secondary: ['proxima-nova'],
      primary: ['roboto']
    },
    // screens: {
    //     'xs': '400px',
    //     'sm': '640px',
    //     'md': '768px',
    //     'lg': '1024px',
    //     'xl': '1476px'
    // },
    screens: {
      sm: '600px',
      md: '768px',
      lg: '800px',
      xl: '1024px',
      '2xl': '1280px',
      '3xl': '1440px',
      '4xl': '1530px',
      '5xl': '1720px'
    },
    extend: {
      colors: {
        primary: '#1b1b1b',
        secondary: '#43526e',

        'secondary-one': '#43526e',
        'secondary-two': '#209cee',
        'secondary-three': '#1b1b1b',
        'secondary-four': '#f8f9fa',
        'secondary-five': '#696969',
        'secondary-six': '#14BDAB',
        'secondary-seven': '#12a797',
        'secondary-eight': '#69696933'
      },
      spacing: {
        7: '1.75rem',
        9: '2.25rem',
        30: '7.5rem'
      },
      fontSize: {
        10: '10px',
        12: '12px',
        14: '14px',
        15: '15px',
        18: '18px',
        16: '16px',
        20: '20px',
        24: '24px',
        28: '28px',
        30: '30px',
        32: '32px',
        36: '36px',
        40: '40px'
      },
      zIndex: {
        60: 60,
        70: 70,
        80: 80,
        90: 90,
        100: 100
      },
      borderRadius: {
        4: '4px',
        10: '10px',
        50: '50px'
      },
      lineHeight: {
        20: '20px',
        24: '24px',
        32: '32px',
        34: '34px',
        36: '36px',
        38: '38px',
        42: '42px',
        50: '50px',
        52: '52px'
      },
      padding: {
        '10px': '10px'
      }
    }
  },
  variants: {
    fontWeight: ['responsive', 'hover', 'focus', 'active', 'group-hover']
  },
  plugins: [
    function ({ addComponents }) {
      addComponents({
        '.container': {
          width: '100%',
          paddingRight: 20,
          paddingLeft: 20,
          margin: '0 auto',
          '@screen sm': {
            width: '520px',
            paddingLeft: 0,
            paddingRight: 0
          },
          '@screen md': {
            width: '668px',
            paddingLeft: 0,
            paddingRight: 0
          },
          '@screen lg': {
            width: '700px',
            paddingLeft: 0,
            paddingRight: 0
          },
          '@screen xl': {
            width: '924px',
            paddingLeft: 0,
            paddingRight: 0
          },
          '@screen 2xl': {
            width: '1060px',
            paddingLeft: 0,
            paddingRight: 0
          },
          '@screen 3xl': {
            width: '1320px',
            paddingLeft: 0,
            paddingRight: 0
          },
          '@screen 4xl': {
            width: '1410px',
            paddingLeft: 0,
            paddingRight: 0
          },
          '@screen 5xl': {
            width: '1600px',
            paddingLeft: 0,
            paddingRight: 0
          }
        }
      });
    },
    plugin(function ({ addBase, config, theme }) {
      const mobile = {
        h1: {
          fontSize: `${config('theme.fontSize.28')} !important`,
          fontFamily: `${config('theme.fontFamily.secondary')} !important`,
          lineHeight: `${config('theme.lineHeight.36')} !important`,
          fontWeight: 'bold',
          color: `${config('theme.colors.primary')} !important`
        },
        h2: {
          fontSize: `${config('theme.fontSize.24')} !important`,
          fontFamily: `${config('theme.fontFamily.secondary')} !important`,
          lineHeight: `${config('theme.lineHeight.32')} !important`,
          fontWeight: 'bold',
          color: `${config('theme.colors.primary')} !important`
        },
        h3: {
          fontSize: `${config('theme.fontSize.24')} !important`,
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          lineHeight: `${config('theme.lineHeight.32')} !important`,
          fontWeight: 'medium',
          color: `${config('theme.colors.primary')} !important`
        },
        h4: {
          fontSize: `${config('theme.fontSize.15')} !important`,
          fontFamily: `${config('theme.fontFamily.secondary')} !important`,
          lineHeight: `${config('theme.lineHeight.24')} !important`,
          fontWeight: 'bold',
          color: `${config('theme.colors.primary')} !important`
        },
        h5: {
          fontSize: `${config('theme.fontSize.15')} !important`,
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          lineHeight: `${config('theme.lineHeight.24')} !important`,
          fontWeight: 'bold',
          color: `${config('theme.colors.primary')} !important`
        },
        body: {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: `${config('theme.fontSize.14')}`,
          color: `${config('theme.colors.primary')} !important`
        },
        '.title': {
          fontFamily: `${config('theme.fontFamily.primary')} !important`
        }
      };

      const desktop = {
        [`@media (min-width: ${768}px)`]: {
          h1: {
            fontSize: `${config('theme.fontSize.40')} !important`,
            fontFamily: `${config('theme.fontFamily.secondary')} !important`,
            lineHeight: `${config('theme.lineHeight.52')} !important`,
            fontWeight: 'bold',
            color: `${config('theme.colors.primary')} !important`
          },
          h2: {
            fontSize: `${config('theme.fontSize.32')} !important`,
            fontFamily: `${config('theme.fontFamily.secondary')} !important`,
            lineHeight: `${config('theme.lineHeight.42')} !important`,
            fontWeight: 'bold',
            color: `${config('theme.colors.primary')} !important`
          },
          h3: {
            fontSize: `${config('theme.fontSize.24')} !important`,
            fontFamily: `${config('theme.fontFamily.primary')} !important`,
            lineHeight: `${config('theme.lineHeight.32')} !important`,
            fontWeight: 'medium',
            color: `${config('theme.colors.primary')} !important`
          },
          h4: {
            fontSize: `${config('theme.fontSize.15')} !important`,
            fontFamily: `${config('theme.fontFamily.secondary')} !important`,
            lineHeight: `${config('theme.lineHeight.24')} !important`,
            fontWeight: 'bold',
            color: `${config('theme.colors.primary')} !important`
          },
          h5: {
            fontSize: `${config('theme.fontSize.15')} !important`,
            fontFamily: `${config('theme.fontFamily.primary')} !important`,
            lineHeight: `${config('theme.lineHeight.24')} !important`,
            fontWeight: 'bold',
            color: `${config('theme.colors.primary')} !important`
          },
          body: {
            fontSize: `${config('theme.fontSize.15')} !important`,
            fontFamily: `${config('theme.fontFamily.primary')} !important`,
            lineHeight: `${config('theme.lineHeight.24')} !important`,
            color: `${config('theme.colors.primary')} !important`
          },
          '.title': {
            fontFamily: `${config('theme.fontFamily.primary')} !important`
          }
        }
      };

      const paragraphs = {
        '.paragraph-default': {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: 15,
          lineHeight: '24px',
          fontWeight: 'regular',
          textAlign: 'left'
        },
        '.paragraph-bold': {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: 15,
          lineHeight: '24px',
          fontWeight: 'medium',
          textAlign: 'left'
        },
        '.paragraph-small': {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: 14,
          lineHeight: '20px',
          fontWeight: 'regular',
          textAlign: 'left'
        },
        '.paragraph-large': {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: 20,
          lineHeight: '32px',
          fontWeight: 'regular',
          textAlign: 'left'
        }
      };

      addBase({
        ...mobile,
        ...desktop,
        ...paragraphs
      });
    }),
    plugin(function ({ addUtilities, config }) {
      const editor = {
        '.DraftEditor-editorContainer': {
          zIndex: 0
        },
        '.rdw-link-decorator-icon': {
          display: 'none'
        }
      };

      const common = {
        '.image-viewer-thumbnails': {
          height: 340,
          '@screen 2xl': {
            height: 400
          },
          '@screen 3xl': {
            height: 500
          },
          '@screen 4xl': {
            height: 540
          },
          '@screen 5xl': {
            height: 600
          }
        },
        '.font-semibold': {
          fontWeight: 600
        },

        '.font-medium': {
          fontWeight: 500
        },

        '.dcc-select__control': {
          fontFamily: config('theme.fontFamily.secondary'),
          fontSize: config('theme.fontSize.15'),
          color: config('theme.colors.secondary-three'),
          border: `1px solid ${config('theme.colors.secondary-three')}`,
          borderRadius: 4,
          paddingLeft: 10,
          paddingRight: 10,
          paddingTop: 5,
          paddingBottom: 5,
          lineHeight: '24px',
          outline: 'none',
          boxShadow: 'none',
          maxHeight: 46
        },

        '.home-search-form .dcc-select__control': {
          border: 'none',
          borderBottom: `1px solid ${config('theme.colors.secondary-eight')}`,
          borderRadius: 0
        },

        '.dcc-select__control--is-disabled': {
          backgroundColor: 'white',
          opacity: 0.5
        },

        '.dcc-select__placeholder': {
          color: config('theme.colors.secondary-five'),
          lineHeight: '24px',
          paddingRight: 0,
          paddingLeft: 0
        },

        '.dcc-select__value-container': {
          paddingRight: 0,
          paddingLeft: 0
        },
        '.dcc-select__input': {
          outlineStyle: 'solid',
          outlineWidth: 2,
          outlineColor: 'transparent',
          outlineOffset: 2
        },
        '.no-right-rounded .dcc-select__control': {
          borderBottomLeftRadius: 4,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        },
        '.no-left-rounded .dcc-select__control': {
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 4,
          borderBottomRightRadius: 4
        },
        '.no-right-border .dcc-select__control': {
          borderRight: 0
        },
        '.no-left-border .dcc-select__control': {
          borderLeft: 0
        },

        [`@media (max-width: ${768}px)`]: {
          '.home-search-form .dcc-select__control': {
            borderColor: `${config('theme.colors.secondary-eight')}`,
            paddingBottom: config('theme.spacing.12')
          },

          '.dcc-select__control, input[type="text"], input[type="number"], input[type="email"], textarea': {
            fontSize: '16px !important'
          }
        },

        '.filter-input': {
          padding: '10px 18px'
        },
        '.carousel-image img': {
          width: '100% !important',
          borderTopRadius: `${config('theme.borderRadius.4')} !important`
        },

        '.vehicle-card': {
          borderRadius: `${config('theme.borderRadius.4')} !important`
        },

        '.top-filters-sticky>div': {
          borderBottom: `1px solid ${config('theme.colors.secondary-eight')}`
        },

        '.top-filters-sticky .top-filters-container': {
          paddingTop: config('theme.spacing.5')
        },

        '.segments-top-bar': {
          marginBottom: config('theme.spacing.5')
        },

        '.top-filters-sticky .segments-top-bar': {
          marginBottom: 0
        },

        '.hide-mobile-p .htmlContent p': {
          display: 'none !important'
        },

        '.bold-mobile .htmlContent h1 span strong': {
          color: `${config('theme.colors.secondary')} !important`
        },

        '.mapboxgl-popup-content': {
          padding: 0,
          borderRadius: `${config('theme.borderRadius.4')} !important`
        },

        '.mapboxgl-popup': {
          zIndex: 1
        },

        '.vehicles-compare-parent': {
          width: 'auto !important',
          zIndex: 99999,
          right: 0
        },

        '.vehicles-compare-button': {
          backgroundColor: `${config('theme.colors.secondary-two')} !important`,
          padding: `${config('theme.spacing.5')} !important`,
          fontSize: 18,
          color: 'white',
          borderTopLeftRadius: 10,
          cursor: 'pointer',
          fontFamily: `${config('theme.fontFamily.secondary')} !important`
        },

        '.vehicles-compare-counter': {
          left: '-15px !important',
          backgroundColor: `${config('theme.colors.secondary-two')} !important`,
          fontFamily: `${config('theme.fontFamily.secondary')} !important`
        },

        '.react-date-picker__wrapper': {
          border: 'none !important',
          marginTop: 4
        },

        '.react-date-picker': {
          maxHeight: '50px !important',
          height: '50px !important',
          borderRadius: `${config('theme.borderRadius.4')} !important`
        }
      };

      const commonButton = {
        fontFamily: `${config('theme.fontFamily.secondary')} !important`,
        fontSize: `${config('theme.fontSize.15')} !important`,
        lineHeight: '18px !important',
        fontWeight: 600,
        padding: '12px 20px',
        borderRadius: 4,
        transition: 'all 100ms linear',
        outline: 'none',
        width: 'fit-content'
      };

      const buttons = {
        '.primary-button': {
          ...commonButton,
          color: 'white',
          backgroundColor: `${config('theme.colors.secondary-two')} !important`,

          '&:hover': {
            backgroundColor: `${config('theme.colors.secondary-three')} !important`
          }
        },

        '.secondary-button': {
          ...commonButton,
          border: `1px solid ${config('theme.colors.secondary-three')}`,
          color: `${config('theme.colors.secondary-three')} !important`,
          backgroundColor: `white !important`,

          '&:hover': {
            border: `1px solid ${config('theme.colors.secondary-two')} !important`,
            color: `${config('theme.colors.secondary-two')} !important`
          }
        },

        '.ternary-button': {
          ...commonButton,
          border: `1px solid white`,
          color: `white !important`,

          '&:hover': {
            border: `1px solid ${config('theme.colors.secondary-three')} !important`,
            color: `${config('theme.colors.secondary-three')} !important`
          }
        },

        '.button': {
          ...commonButton,
          backgroundColor: 'white',
          border: 'none',
          color: `${config('theme.colors.secondary-three')} !important`
        },

        '.draw-border': {
          boxShadow: `inset 0 0 0 1px ${config('theme.colors.secondary-three')}`,
          color: `${config('theme.colors.secondary-three')}`,

          '&:hover': {
            color: config('theme.colors.secondary-two')
          },

          '&:hover::before, &:hover::after': {
            borderColor: config('theme.colors.secondary-two')
          }
        }
      };

      const newUtilities = { ...editor, ...common, ...buttons };
      addUtilities(newUtilities);
    })
  ]
};
